import styled, { keyframes, css } from 'styled-components';

const fadeFromRight = keyframes`
from {
  opacity: 0;
  transform: translateX(50px);
}
to{
  opacity: 1;
  transform:translateX(0);
}
`;
interface ContainerProps {
  isFocused?: boolean;
  isFilled?: boolean;
  isErrored?: boolean;
}

export const ContainerRef = styled.div<ContainerProps>`
  display: flex;
  justify-content: stretch;
  align-items: center;

  background: #fff;
  color: #333;
  border-radius: 10px;
  border: 1px solid #ddd;
  padding: 0px 16px;
  position: relative;
  min-height: 60px;
  p,span,h2,h3,h4,h1,table{
      color : #333;
    }
  .ck-content{
    color: #333;
    p,span,h2,h3,h4,h1,table{
      color : #333 !important;
    }
  }

  div.react-datepicker-popper{
    z-index: 1000;
  }

  > span {

    transition: 0.2s all;
    position: absolute;
    left: 16px; top: 15px;
    font-size: 0px;
  }


  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;

      > span {
        display: inline-block;
        position: absolute;
      top: 3px;
        left: 16px;
        color: #333;
        font-size: 10px;
      }
    `}

    > span {
        display: inline-block;
        position: absolute;
      top: 3px;
        left: 16px;
        color: #333;
        font-size: 10px;
      }

  ${props =>
    props.isFocused &&
    css`
      color: #162743;
      border-color: #162743;

      > span {
        display: inline-block;
        position: absolute;
      top: 3px;
        left: 16px;
        color: #333;
        font-size: 10px;
      }
    `}

    ${props =>
    props.isFilled &&
    css`
        color: #162743;
        > span {
          display: inline-block;
          position: absolute;
          top: 3px;
          left: 16px;
          color: #fff;
          font-size: 10px;
        }
      `}



  & + div {
    margin-top: 8px;
  }

  svg {
    font-size: 16px;
    margin-right: 16px;
  }



  input {
    width: 100%;
    border: 0;
    color: #333;
    padding: 16px;
    background: transparent;

    &::placeholder {
      color: #777;
    }
  }
`;

export const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #f5f7fa;
  min-height: 100vh;
  
  p,span,h2,h3,h4,h1,table{
      color : #4e5768;
    }
  .ck-editor{
    width: 100%;
  }

  div{
    min-height : auto;
  }

  input{
    padding: 10px;
  }

  .button {
    padding: 10px 20px;
    background: #162743;
    color: #fff;
    border: 0px;
    border-radius: 10px;

  }

  select {
    padding: 10px 20px;
    background: #fff;
    color: #162743;
    border: 0px;
    border-radius: 10px;
  }

.max-500{
  max-width: '500px';
}

form >div{
  padding: 0px;
  width: 100%;
}
  
`;

export const Board = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
`;

export const Column = styled.div`
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 0 12px rgba(0,0,0,0.05);

`;

export const TicketCard = styled.div`
  background: #fff;
  border-left: 5px solid #007bff;
  padding: 15px;
  width: 100%;
 
  border-radius: 0px;
  margin-bottom: 10px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;

  figure, img{
    width: 100%;
    max-width: 100%;
  }

  h4 {
    font-size: 1rem;
    margin-bottom: 5px;
  }

  p {
    font-size: 0.85rem;
    color: #555;
    margin: 2px 0;
    line-height: 1.2;

    p,h2,strong{
      word-wrap: break-word; /* Padrão antigo */
  overflow-wrap: break-word; /* Padrão moderno */
    }

  }

  .meta {
    font-size: 0.75rem;
    color: #999;
  }
`;


export const MessageBox = styled.div`
  background: #fff;
 
  padding: 30px;
 

  figure, img{
    width: 100%;
    max-width: 100%;
  }

 
`;